<div id="wizard">

  <div [ngClass]="{'submitted': formSubmitted, 'not-submitted': !formSubmitted }" data-cy="wizard-div-header"
    id="wizard-header">
    <ul>
      @for (step of _steps; track step; let index = $index; let isLast = $last) {
        <app-wizard-header
          (click)="step.select()"
          (keydown)="_onKeydown($event)"
          [active]="selectedIndex === index"
          [formSubmitted]="formSubmitted"
          [id]="_getStepLabelId(index)"
          [index]="index"
          [label]="step.stepLabel || step.label"
          [optional]="step.optional"
          [selected]="selectedIndex === index"
          [tabIndex]="_getFocusIndex() === index ? 0 : -1"
          data-cy="wizard-header-tab">
        </app-wizard-header>
        @if (!isLast) {
          <div class="wizard-header-step-separator"></div>
        }
      }
    </ul>
  </div>

  <div class="wizard-body" data-cy="wizard-div-body">
    @for (step of _steps; track step; let i = $index) {
      <div
        [id]="_getStepContentId(i)"
        role="tabpanel"
        >
        @if (selectedIndex === i) {
          <ng-container [ngTemplateOutlet]="step.content"></ng-container>
        }
      </div>
    }
  </div>

  <div id="wizard-footer">
    <div id="wizard-footer-wrapper">
      <app-wizard-footer
        (back)="previous()"
        (closeAction)="close()"

        (continue)="continue()"
        (discardAction)="discard()"

        (saveAction)="save()"
        (sendAction)="send()"
        [backBtn]="selectedIndex > 0"

        [closeBtn]="formSubmitted"
        [disableContinue]="disableContinue"

        [disableSave]="disableSave"
        [disableSend]="disableSend"

        [finishBtn]="selectedIndex === _steps.length - 1"

        [sendBtn]="!formSubmitted">
      </app-wizard-footer>
    </div>
  </div>

</div>
